import { render, staticRenderFns } from "./IndicadorComprasVentas.vue?vue&type=template&id=aab143fa&"
import script from "./IndicadorComprasVentas.vue?vue&type=script&lang=js&"
export * from "./IndicadorComprasVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports